export const beautyFileSize = (fileSize: number) => {
  if (fileSize < 1024) {
    return `${fileSize} B`;
  } else if (fileSize < 1024 * 1024) {
    return `${(fileSize / 1024).toFixed(1)} KB`;
  } else if (fileSize < 1024 * 1024 * 1024) {
    return `${(fileSize / (1024 * 1024)).toFixed(1)} MB`;
  } else {
    return `${(fileSize / (1024 * 1024 * 1024)).toFixed(1)} GB`;
  }
};
